import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0731a3da"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Filtro de Funções", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "Selecione a função desejada", -1))
const _hoisted_3 = { class: "btn-text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Limpar", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-white" }, "Aplicar", -1))
const _hoisted_6 = { class: "btn-text" }

import { ref, onMounted, watch } from 'vue';
import { AtomButton } from '@/components/atoms';
import { MoleculeCard } from '.'
import { get } from "@/core/service/RolesService";
import { Role } from '@/core/model';
interface IProps {
  isCard?: boolean;
  clear?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeFunctionFilter',
  props: {
    isCard: { type: Boolean },
    clear: { type: Boolean }
  },
  emits: ['handleFilter', 'handleCancel'],
  setup(__props: any, { emit: __emit }) {

const data = ref<number>();
const roles = ref<Role[]>([])

const props = __props
const emit = __emit;
onMounted(() => {
  if (!roles.value.length)
    get().then(data => {
      roles.value = data.data;
    })
});
function handleFilter()
{
  if (data.value)
    emit("handleFilter", data.value)
}

function handleCancel() {
  data.value = undefined;
  emit("handleCancel", undefined);
}

watch(
  () => data.value,
  () => {
    handleFilter();
  });
watch(() => props.clear,
  () => {
    handleCancel();
  })

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_item = _resolveComponent("v-card-item")!

  return (props.isCard)
    ? (_openBlock(), _createBlock(_unref(MoleculeCard), {
        key: 0,
        class: "width-card w-100"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pb-0"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pt-0"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "d-flex flex-column gap-1"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roles.value, (item, index) => {
                        return (_openBlock(), _createBlock(_unref(AtomButton), {
                          background: "transparent",
                          outlined: "",
                          noHover: "",
                          class: _normalizeClass(["text-bold w-100 text-sm pa-1", { active: data.value == item.id }]),
                          key: String(index),
                          onClick: _withModifiers(($event: any) => {data.value = item.id;}, ["prevent"])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_3, _toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["class", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider, { class: "my-3" }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(AtomButton), {
                        background: "transparent",
                        outlined: "",
                        noHover: "",
                        class: "text-bold w-100 text-sm pa-1 my-1",
                        onClick: handleCancel
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(AtomButton), {
                        class: "text-bold w-100 text-sm pa-1 my-1 btn-submit",
                        onClick: handleFilter
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(roles.value, (item, index) => {
        return (_openBlock(), _createBlock(_unref(AtomButton), {
          background: "transparent",
          class: _normalizeClass(["btn-border text-bold w-100 text-sm pa-1 my-1", { active: data.value == item.id }]),
          key: String(index),
          onClick: _withModifiers(($event: any) => {data.value = data.value == item.id ? undefined : item.id;}, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_6, _toDisplayString(item.name), 1)
          ]),
          _: 2
        }, 1032, ["class", "onClick"]))
      }), 128))
}
}

})